import { useTokenProvider, AuthenticationToken } from 'infrastructure/security/authentication/DefaultTokenProvider';
import { ApiAuthenticationProvider, AuthHeader } from 'framework/api';

const useApiAuthenticationProvider = (): ApiAuthenticationProvider => {
  const { getToken } = useTokenProvider();

  const getAuthHeader = async (): Promise<AuthHeader> => {
    const accessToken: AuthenticationToken = await getToken();

    return {
      name: 'Authorization',
      value: `Bearer ${accessToken}`,
    };
  };

  return {
    getAuthHeader,
  };
};

export default useApiAuthenticationProvider;
